import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchUser } from '@mobile-dev/platform/common/redux/actions/AmplifyUserAction'
import { Link } from 'react-router-dom'
import avatar from '../../assets/images/avatar.svg'
import Loader from '../Common/Loader';
import { getApplicationFlow } from '../../Utils/Utility'
import { injectIntl } from 'react-intl';
import { isMobile } from 'react-device-detect'


// TODO: long email and carriar name UI css failing , connect with bala

function ProfileInfo({ intl }) {

    const flow = getApplicationFlow() === 'Carrier' ? 'Carrier' : 'Driver'
    const auth = useSelector(state => state.amplifyUser);
    const userData = auth.user.attributes;
    const dispatch = useDispatch();
    const { formatMessage } = intl;

    const [picture, setPicture] = useState('');

    useEffect(() => {
        if (auth.profilePic) {
            setPicture(auth.profilePic);
        }
    }, [auth.profilePic]);

    useEffect(() => {
        dispatch(fetchUser());
    }, [])

    if (!userData) return <Loader />

    return (

        <div className="content-page">
            {userData &&
                <div className="content">
                    <div className="contest_input_block">
                        <div className="top_header_bar border-bottom">
                            <div className="row">
                                {isMobile &&
                                    <>
                                        <div className="col-sm col-xl-4 d-flex align-items-center p-0" style={{ width: 'auto', flexGrow: 1 }}>
                                            <h3 className="mb-0" title="Load status">{formatMessage({ id: "app.profile" })}</h3>
                                        </div>
                                        <div className='col-sm-6 col-xl-8 d-flex justify-content-end' style={{ width: 'auto' }}>
                                            <div className="align-items-center">
                                                <Link to='/'>
                                                    <button className="btn-bg-none">
                                                        <i className="fal fa-home fa-fw"></i>
                                                    </button>
                                                </Link>
                                            </div>
                                            <div className="align-items-center">
                                                <Link to='/edit'>
                                                    <button className="btn-bg-none">
                                                        <i className="fal fa-edit fa-fw edit"></i></button>
                                                </Link>
                                            </div>
                                        </div>

                                    </>
                                }
                                {!isMobile &&
                                    <>
                                        <div className="col-sm col-xl-4 d-flex align-items-center p-0">
                                            <h3 className="mb-0" title="Load status">{formatMessage({ id: "app.profile" })}</h3>
                                        </div>
                                        <div className='col-sm-6 col-xl-8 d-flex  justify-content-end'>
                                            <div className="align-items-center header-btn-block">
                                                <Link to='/'>
                                                    <button className="btn btn-chartreuse justify-content-center min-width mr-2"
                                                    >
                                                        <i className="fal fa-home fa-fw"></i>&nbsp; {formatMessage({ id: "app.home" })}</button>
                                                </Link>
                                            </div>

                                            <div className="align-items-center header-btn-block">
                                                <Link to='/edit'>
                                                    <button className="btn btn-chartreuse justify-content-center min-width mr-2"
                                                    >
                                                        <i className="fal fa-edit fa-fw"></i>&nbsp; {formatMessage({ id: "app.edit" })}</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </>

                                }

                            </div>
                        </div>

                        <div className="container_block" style={{ padding: '40px' }}>
                            <div className="row">
                                <div className="col-12">


                                    <div className="met-profile">
                                        <div className="row">
                                            <div className="col-lg-4 align-self-center mb-3 mb-lg-0">
                                                <div className="met-profile-main">
                                                    <div className="met-profile-main-pic">
                                                        <img src={picture || avatar} alt=""
                                                            className="rounded-circle" />
                                                    </div>
                                                    <div className="met-profile_user-detail">
                                                        <h5 className="met-user-name">{userData.given_name} {userData.family_name}</h5>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="col-lg-8 align-self-center">
                                                <ul className="list-unstyled personal-detail mb-0">
                                                    <li className=""><i className="fal fa-phone-alt fa-fw mr-2 text-secondary font-22 align-middle"></i>
                                                        <b> {formatMessage({ id: "app.mobile_number" })} </b> : {flow === 'Driver' ? userData.phone_number : userData['custom:carrierPhone']}</li>
                                                    <li className="mt-2"><i
                                                        className="fal fa-envelope fa-fw text-secondary font-22 align-middle mr-2"></i>
                                                        <b> {formatMessage({ id: "app.email" })} </b> : <span>{userData.email}</span></li>
                                                    {flow === 'Carrier' && <li className="mt-2"><i className="fal fa-user fa-fw text-secondary font-22 align-middle mr-2"></i>
                                                        <b> {formatMessage({ id: "app.carrier_name" })} </b> : {userData['custom:carrier']}</li>}
                                                </ul>
                                            </div>

                                        </div>

                                    </div>





                                </div>

                            </div>

                        </div>
                    </div>

                </div>
            }
        </div>

    )
}

export default injectIntl(ProfileInfo);
